//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import router from "../router";

export default {
  name: "ProductTableWidget",
  data() {
    return {
      products: [],
      searchQuery: "",
      loading: false,
      disableProductSearch: false,
      debounceTimer: null,
      visibleColumns: [
        "ProductNumber",
        "ProductName",
        "ProductDescription",
        "SupplierName",
        "PriceExVat",
        "ItemsInStock",
        "Unit"
      ],
      columns: [
        {
          name: "ProductNumber",
          align: "left",
          label: this.$t("products.productNo"),
          field: "productNumber",
          sortable: true
        },
        {
          name: "ProductName",
          align: "left",
          label: this.$t("products.name"),
          field: "productName",
          style: "width: 400px",
          sortable: true
        },
        {
          name: "ProductDescription",
          align: "left",
          label: this.$t("products.description"),
          field: "productDescription",
          sortable: true
        },
        {
          name: "SupplierName",
          align: "left",
          label: this.$t("products.supplier"),
          field: "supplierName",
          style: "width:210px",
          sortable: false
        },
        {
          name: "PriceExVat",
          align: "right",
          label: this.$t("products.salesPrice"),
          field: "priceExVat",
          sortable: true
        },
        {
          name: "ItemsInStock",
          align: "right",
          label: this.$t("products.qty"),
          field: "itemsInStock",
          style: "width:90px",
          sortable: true
        },
        {
          name: "Unit",
          align: "left",
          label: this.$t("products.unit"),
          field: "unit",
          style: "width:90px",
          sortable: true
        }
      ],
      pagination: {
        page: 1,
        rowsPerPage: 15,
        sortBy: "ProductNumber",
        descending: false,
        rowsNumber: 0
      },
      fetchDataTimeout: null
    };
  },
  watch: {
    searchQuery: {
      handler: "onSearchQueryChange"
    },
    visibleColumns: {
      handler(newVal) {
        this.$cookies.set("productColumns", newVal.join(","), "1Y");
      },
      deep: true
    },
    loading(newValue, oldValue) {
      if (newValue != oldValue) {
        this.$emit('update-value', newValue)
      }
    },
  },
  methods: {
    ...mapActions("main", ["getSimplifiedProducts"]),
    getSortOrder(col) {
      if (col.sortable && col.name === this.pagination.sortBy) {
        return this.pagination.descending ? "desc" : "asc";
      }
      return null;
    },
    onRequest(params) {
      if (this.loading) return;
      Object.assign(this.pagination, params.pagination);
      this.fetchData();
    },
    onSort(col) {
      if (this.loading) return;
      if (col.sortable) {
        if (this.pagination.sortBy === col.name) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = col.name;
          this.pagination.descending = false;
          this.pagination.page = 1;
        }
        this.fetchData();
      }
    },
    onSearchQueryChange() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(() => {
        this.pagination.page = 1;
        this.fetchData();
      }, 1500);
    },
    fetchData() {
      if (this.fetchDataTimeout) {
        clearTimeout(this.fetchDataTimeout);
      }
      this.fetchDataTimeout = setTimeout(async () => {
        if (this.loading) return;
        this.loading = true;
        let sortBy = this.pagination.sortBy || "ProductNumber";
        let sortDescending = this.pagination.descending;
        const sortColumn = this.columns.find(col => col.name === sortBy);
        if (!sortColumn || !sortColumn.sortable) {
          sortBy = "ProductNumber";
          sortDescending = false;
          Object.assign(this.pagination, {
            sortBy: sortBy,
            descending: sortDescending
          });
        }
        const params = {
          pageNumber: this.pagination.page,
          pageSize: this.pagination.rowsPerPage,
          searchQuery: this.searchQuery,
          sortBy: sortBy,
          sortDescending: sortDescending
        };
        try {
          const data = await this.getSimplifiedProducts(params);
          this.products = data.items;
          this.pagination.rowsNumber = data.totalCount;
        } catch (error) {
          console.error("Error fetching products:", error);
          this.$q.notify({
            type: "negative",
            message: this.$t("common.errorFetchingData")
          });
        } finally {
          this.loading = false;
        }
      }, 300);
    },
    onRowClick(evt, row) {
      this.$emit("row-click", row);
    },
    refresh() {
      this.disableProductSearch = true;

      this.fetchData();

      this.disableProductSearch = false;
    },
    initVisibleColumns() {
      const cookieColumns = this.$cookies.get("productColumns");
      if (cookieColumns) {
        this.visibleColumns = cookieColumns.split(",");
      }
    },
    enterCheck(event) {
      if (event.key === "Enter" && this.filter != "") {
        var products = this.$refs.productTable.computedRows;
        if (products.length == 1) {
          this.openProduct(products[0].id);
        }
      }
    },
    openProduct(productId) {
      router.push({
        name: "EditProduct",
        params: { id: productId }
      });
    },
  },
  mounted() {
    this.initVisibleColumns();
    this.fetchData();
  },
  beforeDestroy() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    if (this.fetchDataTimeout) {
      clearTimeout(this.fetchDataTimeout);
    }
  }
};
